import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslocoModule } from '@jsverse/transloco';

import { CarouselModule } from '@app/modules/carousel/carousel.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ImageModule } from '@ux/components/image/image.module';
import { ScoreDetailModule } from '@shared/score-detail/score-detail.module';
import { TooltipDirectiveModule } from '@ux/directives/tooltip/tooltip-directive.module';

import { SlidePromoComponent } from '@shared/sliders/components/slide-promo/slide-promo.component';
import { SlideStoreComponent } from '@shared/sliders/components/slide-store/slide-store.component';
import { SlideTileComponent } from '@shared/sliders/components/slide-tile/slide-tile.component';
import { SlideBannerComponent } from '@shared/sliders/components/slide-banner/slide-banner.component';
import { SlideHotelPromoComponent } from '@shared/sliders/components/slide-hotel-promo/slide-hotel-promo.component';
import { SlideFlightOffersComponent } from '@shared/sliders/components/slide-flight-offers/slide-flight-offers.component';
import { MemberRateTagModule } from '@ux/components/member-rate-tag/member-rate-tag.module';
import { MarriottStoreBadgeModule } from '@ux/components/marriott-store-badge/marriott-store-badge.module';
import { BenefitsModule } from '@shared/benefits/benefits.module';
import { TagMemberDsComponent } from '@design-system/components/molecules/tag-member/tag-member.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { TagProductDsComponent } from '@design-system/components/organisms/tag-product/tag-product.component';
import { TagCategoryDsComponent } from '@design-system/components/molecules/tag-category/tag-category.component';
import { TagHighlightDsComponent } from '@design-system/components/molecules/tag-highlight/tag-highlight.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { SlideModule } from '@ux/components/slide/slide.module';
import { GenericCardDsComponent } from '@design-system/components/templates/generic-card/generic-card.component';

@NgModule({
  declarations: [
    SlidePromoComponent,
    SlideStoreComponent,
    SlideTileComponent,
    SlideBannerComponent,
    SlideFlightOffersComponent,
    SlideHotelPromoComponent
  ],
  imports: [
    CarouselModule,
    CommonModule,
    OverlayModule,
    ImageModule,
    TranslocoModule,
    GlobalPipesModule,
    RouterModule,
    ScoreDetailModule,
    TooltipDirectiveModule,
    MemberRateTagModule,
    MarriottStoreBadgeModule,
    MemberRateTagModule,
    BenefitsModule,
    SlideModule,
    TagMemberDsComponent,
    TypographyDsComponent,
    IconDsComponent,
    DividerDsComponent,
    TagProductDsComponent,
    TagCategoryDsComponent,
    TagHighlightDsComponent,
    ButtonIconDsComponent,
    GenericCardDsComponent,
  ],
  exports: [
    SlidePromoComponent,
    SlideStoreComponent,
    SlideTileComponent,
    SlideBannerComponent,
    SlideFlightOffersComponent,
    SlideHotelPromoComponent
  ]
})
export class SlidersModule { }
